// Предупреждение о cookies: показываем, пока посетитель не нажал «Хорошо».
// Факт согласия храним в cookie на год (работает и без localStorage).

const COOKIE_NAME = "cookie_agree";
const MAX_AGE = 60 * 60 * 24 * 365;

export function initCookieNotice() {
	const box = document.querySelector("[data-cookie-notice]");
	if (!box) return;
	if (document.cookie.split("; ").some((c) => c === `${COOKIE_NAME}=1`)) return;

	box.hidden = false;

	const btn = box.querySelector("[data-cookie-accept]");
	if (btn) btn.addEventListener("click", () => {
		document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
		box.hidden = true;
	});
}
